import React from 'react';

const WeddingContext = React.createContext();

export default WeddingContext;
